// extracted by mini-css-extract-plugin
module.exports = {"highlightText":"landing_highlightText__MAiiK","whatisflex":"landing_whatisflex__s1wN5","property":"landing_property__ZWUsE","heroBackground":"landing_heroBackground__rVO0Z"};